export enum AggregateReportState {
  NOT_GENERATED = 'NOT_GENERATED',
  GENERATED = 'GENERATED',
}
